module.exports = __webpack_public_path__ + "ai.svg?101c87c14170fb406a26349aeb008e36";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/ai.svg
// module id = 738
// module chunks = 27